module.exports = __webpack_public_path__ + "static/media/flow.11177c90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/yelp/src/flow.jpg
// module id = 655
// module chunks = 0